const currenciesActionTypes = {
  GET_CURRENCIES_START: 'GET_CURRENCIES_START',
  GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_FAILURE: 'GET_CURRENCIES_FAILURE',
  REMOVE_CURRENCIES: 'REMOVE_CURRENCIES',

  GET_MAIN_CURRENCY_START: 'GET_MAIN_CURRENCY_START',
  GET_MAIN_CURRENCY_SUCCESS: 'GET_MAIN_CURRENCY_SUCCESS',
  GET_MAIN_CURRENCY_FAILURE: 'GET_MAIN_CURRENCY_FAILURE',
};

export default currenciesActionTypes;
